import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { Base_URL, imageBaseURL } from "../../../actions/API_endpoint";

const ManageGalleryImages = () => {
    const { id } = useParams();
    const [gallery, setGallery] = useState(null);
    const [selectedFiles, setSelectedFiles] = useState(null);
    const [uploading, setUploading] = useState(false);

    useEffect(() => {
        fetchGallery();
    }, [id]);

    const fetchGallery = async () => {
        try {
            const response = await axios.get(`${Base_URL}/api/galleries/${id}`);
            if (response.data.success) {
                setGallery(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching gallery:", error);
        }
    };

    const handleFileChange = (e) => {
        setSelectedFiles(e.target.files);
    };

    const handleUpload = async (e) => {
        e.preventDefault();
        if (!selectedFiles) return;

        const formData = new FormData();
        for (let i = 0; i < selectedFiles.length; i++) {
            formData.append("images", selectedFiles[i]);
        }

        setUploading(true);
        try {
            await axios.post(`${Base_URL}/api/galleries/${id}/images`, formData);
            alert("Images uploaded successfully!");
            setSelectedFiles(null);
            fetchGallery(); // Refresh images
        } catch (error) {
            console.error("Error uploading images:", error);
            alert("Error uploading images.");
        } finally {
            setUploading(false);
        }
    };

    if (!gallery) return <div>Loading...</div>;

    return (
        <div className="w-full mb-12 px-4 shadow-lg rounded bg-white/5 backdrop-blur-2xl border border-white/20 py-6 text-white">
            <div className="flex justify-between items-center mb-6">
                <h3 className="font-semibold text-lg text-white">
                    Gallery: {gallery.name}
                </h3>
                <Link to="/admin/galleries" className="text-lightBlue-400 hover:text-lightBlue-300 font-bold">
                    &larr; Back to Galleries
                </Link>
            </div>

            {/* Upload Area */}
            <div className="mb-8 p-6 bg-white/10 rounded-lg border border-dashed border-white/20">
                <h4 className="font-bold mb-4 text-white">Upload Images</h4>
                <form onSubmit={handleUpload} className="flex gap-4 items-center">
                    <input
                        type="file"
                        multiple
                        onChange={handleFileChange}
                        className="border border-white/20 bg-white/5 p-2 rounded text-white"
                    />
                    <button
                        type="submit"
                        disabled={uploading}
                        className="bg-lightBlue-600 text-white px-4 py-2 rounded hover:bg-lightBlue-500 disabled:opacity-50 border border-white/20"
                    >
                        {uploading ? "Uploading..." : "Upload Selected Images"}
                    </button>
                </form>
            </div>

            {/* Image Grid */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {gallery.images && gallery.images.length > 0 ? (
                    gallery.images.map((img) => (
                        <div key={img.id} className="relative group">
                            <img
                                src={`${imageBaseURL}${img.image_path}`}
                                alt={img.caption || "Gallery"}
                                className="w-full h-40 object-cover rounded shadow border border-white/10"
                            />
                            {/* Deletion logic could be added here later */}
                        </div>
                    ))
                ) : (
                    <p className="text-blueGray-300 col-span-4 text-center">No images uploaded yet.</p>
                )}
            </div>
        </div>
    );
};

export default ManageGalleryImages;
